import { ApiService } from "@/api";

export const getStashedAnswer = (sampleId: string) => {
  return ApiService.baseAction(`answer/cache/${sampleId}`, {}, "GET");
};
